module.exports = __webpack_public_path__ + "img/6.4f1e2e21.jpg";